import script from "./HelpText.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpText.vue?vue&type=script&lang=ts&setup=true"

import "./HelpText.vue?vue&type=style&index=0&id=3b30180a&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b30180a"]])

export default __exports__